"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeStairs = void 0;
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var diveTileData_sidecar_1 = require("../../tilemap/diveTileData-sidecar");
var diveTileData_1 = require("../../tilemap/diveTileData");
var diveTilemapPart_sidecar_1 = require("../../tilemap/diveTilemapPart-sidecar");
var genUtils_1 = require("../common/genUtils");
var diveDebug_sidecar_1 = require("@dive/debug/diveDebug-sidecar");
function placeStairs(info, options) {
    var rnd, openFloors, stairsUp, stairsDown, iAttempt, spot, iAttempt, spot, dist;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                rnd = info.rnd, openFloors = info.openFloors;
                stairsUp = null;
                stairsDown = null;
                for (iAttempt = 0; iAttempt < 250; iAttempt++) {
                    if (openFloors.length === 0) {
                        break;
                    }
                    spot = rnd.sampleAndRemove(openFloors);
                    if (genUtils_1.isClear8(spot.i, spot.j)) {
                        stairsUp = spot;
                        diveTilemapPart_sidecar_1.diveTilemapPart.setTile(spot, diveTileData_sidecar_1.diveTileData.get(diveTileData_1.EDiveTile.StairsUp));
                        break;
                    }
                    // Try again
                }
                if (!!stairsUp) return [3 /*break*/, 2];
                // Reset
                return [4 /*yield*/, { command: 'reset', reason: 'no stairs up' }];
            case 1:
                // Reset
                _a.sent();
                _a.label = 2;
            case 2:
                if (stairsUp) {
                    for (iAttempt = 0; iAttempt < 250; iAttempt++) {
                        if (openFloors.length === 0) {
                            break;
                        }
                        spot = rnd.sampleAndRemove(openFloors);
                        dist = mathUtils_sidecar_1.mathUtils.distance(spot.i, spot.j, stairsUp.i, stairsUp.j);
                        if (diveDebug_sidecar_1.diveDebug.debug_stairsCloseToEachOther) {
                            if (dist > 8) {
                                continue;
                            }
                        }
                        else {
                            if (dist <= options.minStairDistance) {
                                continue;
                            }
                        }
                        if (genUtils_1.isClear8(spot.i, spot.j)) {
                            stairsDown = spot;
                            diveTilemapPart_sidecar_1.diveTilemapPart.setTile(spot, diveTileData_sidecar_1.diveTileData.get(diveTileData_1.EDiveTile.StairsDown));
                            break;
                        }
                        // Try again
                    }
                }
                if (!!stairsDown) return [3 /*break*/, 4];
                // Reset
                return [4 /*yield*/, { command: 'reset', reason: 'no stairs down' }];
            case 3:
                // Reset
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
exports.placeStairs = placeStairs;
